// extracted by mini-css-extract-plugin
module.exports = {"linkButton":"LinkButton_linkButton__8Ligi","has_border":"LinkButton_has_border__6T_Nl"};